/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/sheets/QaPhoneMoveSheet.tsx
 * FILE_ID: JOBHUB-QA-PHONE-MOVE-001
 * PURPOSE: Host the existing QaMoveDialog body inside MobileSheet.
 */
import { MobileSheet } from '@quotech/ui'
import { QaMoveDialog, type QaMoveTarget } from '../../QaMoveDialog'
import { QA_PHONE_CONTROLS } from '../qaPhoneControlInventory'

export function QaPhoneMoveSheet({
  open,
  onClose,
  count,
  label,
  targets,
  allowNewLevel,
  busy,
  error,
  onMove,
}: {
  open: boolean
  onClose: () => void
  count: number
  label: string
  targets: QaMoveTarget[]
  allowNewLevel: boolean
  busy?: boolean
  error?: string | null
  onMove: (destination: { parentId: string } | { newLevelName: string }) => void
}) {
  return (
    <MobileSheet open={open} onClose={onClose} title="Move" size="full">
      <div data-qa-phone-control={QA_PHONE_CONTROLS.move} className="p-3">
        <QaMoveDialog
          count={count}
          label={label}
          targets={targets}
          allowNewLevel={allowNewLevel}
          busy={busy}
          error={error}
          onCancel={onClose}
          onMove={onMove}
        />
      </div>
    </MobileSheet>
  )
}
